module.exports = __webpack_public_path__ + "static/media/user_is_pro_warn.a109bae4.png";